export function normalizeModelName(modelName, country = '') {
    if (country === 'mgMotorsSpain') {
        switch (modelName) {
            case 'zs-2024':
                return 'MG ZS';
            case 'zs-hev':
            case 'zs-hev-2026-5':
                return 'MG ZS HEV';
            case 'mg3-gasolina':
                return 'MG3 Gasolina';
            case 'mg-hs-phev':
                return 'MG HS PHEV';
            case 'mg-hs-2024':
                return 'MG HS';
            case 'mg-ehs-2024':
            case 'hs-phev-2026-5':
                return 'MG HS PHEV';
        }
    }

    if (country === 'mgMotorsPoland') {
        switch (modelName) {
            case 'mg-ehs-2024':
            case 'hs-phev-2026-5':
                return 'MG HS PHEV';
            case 'mg-hs-2024':
                return 'MG HS';
            case 'mg3':
                return 'MG3 Hybrid+';
        }
    }

    switch (modelName) {
        case 'ehs':
        case 'mgEhs':
        case 'mg-ehs':
        case 'hs-phev':
            return 'MG EHS';

        case 'marvel-r':
        case 'mg-marvel-r':
        case 'mgMarvelR':
        case 'marvelR':
            return 'MG MARVEL R';

        case 'zs-ev':
        case 'mg-zs-ev':
        case 'mgZsEv':
            return 'MG ZS EV';

        case 'zs':
        case 'mg-zs':
        case 'mgZs':
        case 'mgZsPetrol':
        case 'mg-zs-ice-2024':
        case 'mg-zs-ice-2026-5':
            return 'MG ZS';

        case 'hs':
        case 'mg-hs':
        case 'mgHs':
            return 'MG HS';

        case 'mg-4':
        case 'mg4-2023':
        case 'mg4-2024':
        case 'mg4':
            return 'MG4';

        case 'mg3':
        case 'mg3-hev':
        case 'mg3-hev-2026':
        case 'mg3-hev-2026-5':
        case 'mg3-ice':
        case 'mg3-ice-2024':
        case 'mg3-ice-2026-5':
            return 'MG3';

        case 'cyberster':
            return 'Cyberster';

        case 'mg-5':
        case 'mg5':
            return 'MG5';

        case 'zs-hev':
        case 'zs-hev-2026-5':
            return 'MG ZS Hybrid+';

        case 'mgs5':
            return 'MGS5 EV';

        case 'hs-hev':
        case 'hs-hev-2025':
        case 'hs-hev-2026-5':
            return 'MG HS Hybrid+';
        case 'ehs-hev':
            return 'EHS Hybrid+';
        case 'hs-phev':
            return 'MG HS PHEV';
        case 'mgs9-phev':
        case 'mgs9-phev-2026':
            return 'MGS9 PHEV';
        case 'mg4-urban':
        case 'mg4-urban-ev-2026':
            return 'MG4 EV Urban';
        case 'mg4-mce-2026':
            return 'MG4 EV';

        default:
            return '';
    }
}
